export const SESSION_USER_TOKEN = "smoothstack_user_token";
export const SESSION_EXPIRE_TS = "smoothstack_expire_ts";
